const knightsConstantRedux = {
  /*******************Product******************/
  SET_NEW_PRODUCT: "SET_NEW_PRODUCT",
  SET_PRODUCTS_LIST: "SET_PRODUCTS_LIST",
  CONCAT_PRODUCTS_LIST: "CONCAT_PRODUCTS_LIST",
  UPDATE_PRODUCT: "UPDATE_PRODUCT",
  /*******************Customer******************/
  //Invoice
  SET_DRAFT_CUSTOMER_INVOICE: "SET_DRAFT_CUSTOMER_INVOICE",
  SET_CUSTOMER_INVOICE_LIST: "SET_CUSTOMER_INVOICE_LIST",
  SET_NEW_DRAFT_INVIOCE_TO_LIST: "SET_NEW_DRAFT_INVIOCE_TO_LIST",
  DELETE_DRAFT_CUSTOMER_INVOICE: "DELETE_DRAFT_CUSTOMER_INVOICE",
  SET_DRAFT_CUSTOMER_INVOICE_PROPERTY: "SET_DRAFT_CUSTOMER_INVOICE_PROPERTY",
  SET_DRAFT_CUSTOMER_INVOICE_PRODUCT_PROPERTY:
    "SET_DRAFT_CUSTOMER_INVOICE_PRODUCT_PROPERTY",
  SET_DRAFT_CUSTOMER_INVOICE_PRODUCT_DISCOUNT_PROPERTY:
    "SET_DRAFT_CUSTOMER_INVOICE_PRODUCT_DISCOUNT_PROPERTY",
  SET_DRAFT_CUSTOMER_INVOICE_DISCOUNT_PROPERTY:
    "SET_DRAFT_CUSTOMER_INVOICE_DISCOUNT_PROPERTY",
  RESET_DRAFT_CUSTOMER_INVOICE: "RESET_DRAFT_CUSTOMER_INVOICE",
  DELETE_DRAFT_INVOICE_PRODUCT: "DELETE_DRAFT_INVOICE_PRODUCT",
  ADD_DRAFT_INVOICE_PRODUCT: "ADD_DRAFT_INVOICE_PRODUCT",
  SET_DRAFT_CUTOMER_INVOICE_PAID_PRICE: "SET_DRAFT_CUTOMER_INVOICE_PAID_PRICE",
  SET_DRAFT_CUTOMER_INVOICE_DISCOUNT_TYPE:
    "SET_DRAFT_CUTOMER_INVOICE_DISCOUNT_TYPE",
  REST_INVOICE_FUND: "REST_INVOICE_FUND",
  REST_INVOICE_FUND_WITHOUT_PRODUCT: "REST_INVOICE_FUND_WITHOUT_PRODUCT",
  SET_DRAFT_CUSTOMER_INVOICE_NAME: "SET_DRAFT_CUSTOMER_INVOICE_NAME",
  //customer
  SET_CUSTOMER_LIST: "SET_CUSTOMER_LIST",
  SET_EDIT_CUSTOMER: "SET_EDIT_CUSTOMER",
  SET_EDIT_CUSTOMER_PROPERTY: "SET_EDIT_CUSTOMER_PROPERTY",
  RESET_EDIT_CUSTOMER: "RESET_EDIT_CUSTOMER",
  DELETE_CUSTOMER: "DELETE_CUSTOMER",
  /*******************Category******************/
  SET_CATEGORY_LIST: "SET_CATEGORY_LIST",
  DELETE_CATEGORY: "DELETE_CATEGORY",
  EDIT_CATEGORY: "EDIT_CATEGORY",
  UPDATE_CATEGORY: "UPDATE_CATEGORY",
  ADD_CATEGORY: "ADD_CATEGORY",
  EDIT_CATEGORY_PROPERTY: "EDIT_CATEGORY_PROPERTY",
  /*******************Company******************/
  SET_COMPANY_LIST: "SET_COMPANY_LIST",
  DELETE_COMPANY: "DELETE_COMPANY",
  EDIT_COMPANY: "EDIT_COMPANY",
  UPDATE_COMPANY: "UPDATE_COMPANY",
  ADD_COMPANY: "ADD_COMPANY",
  EDIT_COMPANY_PROPERTY: "EDIT_COMPANY_PROPERTY",
  /********************Admin********************/

  /****************User************/
  SET_EDIT_USER: "SET_EDIT_USER",
  EDIT_USER_PROPERTY: "EDIT_USER_PROPERTY",
  SET_EMPLOYEE_LIST: "SET_EMPLOYEE_LIST",
  RESET_EDIT_USER: "RESET_EDIT_USER",
  UPDATE_LANG: "UPDATE_LANG",
  /********Employee Position********/
  SET_EMPLOYEE_POSITION_LIST: "SET_POSITION_LIST",
  EDIT_EMPLOYEE_POSITION: "EDIT_EMPLOYEE_POSITION",
  EDIT_EMPLOYEE_POSITION_PORPERTY: "EDIT_EMPLOYEE_POSITION_PORPERTY",
  RESET_EDIT_EMPLOYEE_POSITION: "RESET_EDIT_EMPLOYEE_POSITION",
  DELETE_EMPLOYEE_POSITION: "DELETE_EMPLOYEE_POSITION",
  /******************Admin Settings*******************/
  //permission
  SET_PERMISSION_LIST: "SET_PERMISSION_LIST",
  EDIT_PERMISSION: "EDIT_PERMISSION",
  EDIT_PERMISSION_PROPERTY: "EDIT_PERMISSION_PROPERTY",
  RESET_EDIT_PERMISSION: "RESET_EDIT_PERMISSION",
  DELETE_PERMISSION: "DELETE_PERMISSION",
  // category permission
  SET_CATEGORY_PERMISSION_LIST: "SET_CATEGORY_PERMISSION_LIST",
  EDIT_CATEGORY_PERMISSION: "EDIT_CATEGORY_PERMISSION",
  EDIT_CATEGORY_PERMISSION_PROPERTY: "EDIT_CATEGORY_PERMISSION_PROPERTY",
  RESET_EDIT_CATEGORY_PERMISSION: "RESET_EDIT_CATEGORY_PERMISSION",
  DELETE_PERMISSION_CATEGORY: "DELETE_PERMISSION_CATEGORY",
  // role
  SET_ROLE_LIST: "SET_ROLE_LIST",
  EDIT_ROLE: "EDIT_ROLE",
  EDIT_ROLE_PROPERTY: "EDIT_ROLE_PROPERTY",
  RESET_EDIT_ROLE: "RESET_EDIT_ROLE",
  DELETE_ROLE_PERMISSION: "DELETE_ROLE_PERMISSION",
  ADD_ROLE_PERMISSION: "ADD_ROLE_PERMISSION",
  DELETE_ROLE: "DELETE_ROLE",
  /*************View Setting***********/
  SET_SHOW_HIDE_CATEGORY: "SET_SHOW_HIDE_CATEGORY",
  SET_FUND_OPEN: "SET_FUND_OPEN",
  SET_VIEW_SETTINGS: "SET_VIEW_SETTINGS",

  /*************App Settings***********/
  EDIT_MAIN_PRICE: "EDIT_MAIN_PRICE",
  EDIT_MAIN_CURRENCY: "EDIT_MAIN_CURRENCY",
  GET_MAIN_CURRENCY: "GET_MAIN_CURRENCY",
  EDIT_COMMISSION: "EDIT_COMMISSION",
  EDIT_lira_round: "EDIT_lira_round",
  EDIT_COINS: "EDIT_COINS",
  DELETE_COINS: "DELETE_COINS",
  SET_COINS_LIST: "SET_COINS_LIST",
  ADD_COINS_ITEM: "ADD_COINS_ITEM",
  GET_COINS: "GET_COINS",
  SET_POS_FEATURES: "SET_POS_FEATURES",
  SET_PRICING_CONFIG: "SET_PRICING_CONFIG",

  EDIT_SERVICE: "EDIT_SERVICE",
  SET_SERVICE_LIST: "SET_SERVICE_LIST",
  ADD_TO_SERVICE_LIST: "ADD_TO_SERVICE_LIST",

  EDIT_PRODUCT_FIELDS: "EDIT_PRODUCT_FIELDS",
  SET_PRODUCT_FIELDS: "SET_PRODUCT_FIELDS",
  CHANGE_PRODUCT_POSITION: "CHANGE_PRODUCT_POSITION",

  SET_CHARGES_TYPE_LIST: "SET_CHARGES_TYPE_LIST",
  EDIT_CHARGE_TYPE: "EDIT_CHARGE_TYPE",
  ADD_CHARGE_TYPE: "ADD_CHARGE_TYPE",
  DELETE_CHARGE_TYPE: "DELETE_CHARGE_TYPE",
  EDIT_DELIMITER: "EDIT_DELIMITER",
  ADD_BARCODE_FIELD: "ADD_BARCODE_FIELD",
  DELETE_BARCODE_FIELD: "DELETE_BARCODE_FIELD",
  EDIT_EXPIRE_PERIOD: "EDIT_EXPIRE_PERIOD",
  SET_INTEGRATION_CONFIG: "SET_INTEGRATION_CONFIG",
  /*************Permission***********/
  SET_PERMISSIONS: "SET_PERMISSIONS",
  SET_USER_LOGIN: "SET_USER_LOGIN",
  SET_USER_LOGOUT: "SET_USER_LOGOUT",
  UPDATE_USER_PROPERTY: "UPDATE_USER_PROPERTY",
  /*************Department***********/
  SET_DEPARTMENT_LISTS: "SET_DEPARTMENT_LISTS",
  SET_DEPARTMENT_ITEM: "SET_DEPARTMENT_ITEM",

  /*************Invoice Templates***********/
  SET_INVOICE_TEMPLATES: "SET_INVOICE_TEMPLATES",
  SET_ACCESS_TOKEN: "SET_ACCESS_TOKEN",
  CLEAR_ACCESS_TOKEN: "CLEAR_ACCESS_TOKEN",
  ADD_INVOICE_TEMPLATE: "ADD_INVOICE_TEMPLATE",
  UPDATE_INVOICE_TEMPLATE: "UPDATE_INVOICE_TEMPLATE",
  DELETE_INVOICE_TEMPLATE: "DELETE_INVOICE_TEMPLATE",
  SET_CURRENT_INVOICE_TEMPLATE: "SET_CURRENT_INVOICE_TEMPLATE",
};

export default knightsConstantRedux;
